/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Box } from '@material-ui/core';
import styles from './styles';

interface PropTypes {
  className?: string;
}

/**
 * Use this to wrap a line of text inside the ActionButtonContainer
 * to get consistent spacing between it and other text variant Buttons.
 */
const TextAction: React.FC = ({ children }) => {
  return <div css={styles.textAction}>{children}</div>;
};
const ActionButtonContainer: React.FC<PropTypes> = props => {
  const { children, className } = props;
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      css={styles.actionsContainer}
      className={className}
    >
      {children}
    </Box>
  );
};

export default ActionButtonContainer;
export { TextAction };
